import { render, staticRenderFns } from "./AssetDescription.vue?vue&type=template&id=5c7bc6f6"
import script from "./AssetDescription.vue?vue&type=script&lang=js"
export * from "./AssetDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports